import { render, staticRenderFns } from "./transferAssign.vue?vue&type=template&id=65cdb7db&scoped=true"
import script from "./transferAssign.vue?vue&type=script&lang=js"
export * from "./transferAssign.vue?vue&type=script&lang=js"
import style0 from "./transferAssign.vue?vue&type=style&index=0&id=65cdb7db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cdb7db",
  null
  
)

export default component.exports